import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
       
         let user = localStorage.getItem('usuarioLogado');
        if (user) {
            // logado para retornar true
            return true;
        }
         console.log('não está logado');
        // não está logado, então redirecione para a página de login com o URL de retorno
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
        return false;
    }
}